<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    data-slot="stat-footer"
    :class="
      cn(
        'flex h-4 w-full items-center justify-between gap-2 text-xs/3 group-data-[align=right]/stat:flex-row-reverse',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
